module.exports = __webpack_public_path__ + "img/_hungary.db31eba9.png";